import React, { Component } from 'react';

class ProtocolButtons extends Component {
	renderAdhereButton() {
		if ( this.props.is_open && 'group' !== this.props.type ) {
			return (
				<span><a href={ `${this.props.link}submit/` } className="btn btn-default">Adhere to this Protocol</a><br /></span>
			);
		}
	}

	renderPartiesButton() {
		if ( 'group' !== this.props.type ) {
			return <a href={ `${this.props.link}adhering-parties/` } className="link-view-adhering-parties">View Adhering Parties</a>;
		}
	}

	render() {
		return <span>
			{ this.renderAdhereButton() }
			{ this.renderPartiesButton() }
		</span>;
	}
}

export default ProtocolButtons;